import * as React from 'react';
import { GlobalApplicationState } from "globalApplicationState";
import { ConnectedProps, connect } from "react-redux";
import {actions} from '..'
import ToggleSwitch from 'modules/common/components/toggleSwitch';
import { NotificationEvents, TenantNotificationSettings } from 'modules/messaging';
import { isAtLeastOnePublishNotifChannelOn } from 'utils/notificationsHelper';
import { Notifications } from 'modules/posts/models';

interface ComponentProps { 
    publishName: keyof TenantNotificationSettings;
    teamsEvent: NotificationEvents;
    mobileEvent: NotificationEvents;
    emailEvent: NotificationEvents;
    smsEvent: NotificationEvents;
}

interface ComponentState {
    defaultsToggleOn: boolean;
}

class AuthoringSettings extends React.Component<PropsWithRedux, ComponentState> {
    constructor(props) {
        super(props);

        this.state = {
            defaultsToggleOn: isAtLeastOnePublishNotifChannelOn(this.props.notificationSettings, this.props.publishName)
        }
    } 

    public render() {
        const {emailDefaultIsNone, smsDefaultIsNone, teamsDefaultIsNone, mobileDefaultIsNone} = this.getDefaultNotifications();

        const settings = this.props.notificationSettings.settings;
    
        return(
            <div className="authoring-prompt">
                <div>
                    <h4>Edit Authoring Default Settings</h4>
                    <span className="description-text">The following details will be the default notification setting for each time a notification is created and/or published.</span>
                </div>
                
                <div className="authoring-settings-zone">
                    <div className="authoring-elements">
                        <div>
                            Turn on <i>‘Notify subscribers upon publishing’</i> setting when creating new posts
                            <ToggleSwitch
                                onClick={this.onToggleClicked}
                                value={this.state.defaultsToggleOn}
                            />
                        </div>
                        <span className="description-text">Upon publishing a notification, employees will be notified through the following channels:</span>

                        <div className="authoring-checkboxes">

                            <div>
                                <input className="authoring-checkboxes-input" type="checkbox"
                                    name="emailOnPublish"
                                    disabled={!settings[this.props.emailEvent].toggle}
                                    onChange={this.toggleAuthoring} 
                                    checked={!emailDefaultIsNone && settings[this.props.emailEvent].toggle}
                                />
                                <span>Email</span>
                            </div>

                            <div>
                                <input className="authoring-checkboxes-input"
                                    type="checkbox"
                                    name="mobileOnPublish"
                                    disabled={!settings[this.props.mobileEvent].toggle}
                                    onChange={this.toggleAuthoring} 
                                    checked={!mobileDefaultIsNone && settings[this.props.mobileEvent].toggle}
                                />
                                <span>Mobile App</span>
                            </div>

                            <div>
                                <input className="authoring-checkboxes-input"
                                    type="checkbox"
                                    name="teamsOnPublish"
                                    disabled={!settings[this.props.teamsEvent].toggle}
                                    onChange={this.toggleAuthoring}
                                    checked={!teamsDefaultIsNone && settings[this.props.teamsEvent].toggle}
                                />
                                <span>MS Teams Chatbot</span>
                            </div>

                            {this.props.smsManagementEnabled &&
                                <div>
                                    <input className="authoring-checkboxes-input" type="checkbox"
                                        name="smsOnPublish"
                                        disabled={!settings[this.props.smsEvent].toggle}
                                        onChange={this.toggleAuthoring} 
                                        checked={!smsDefaultIsNone && settings[this.props.smsEvent].toggle}
                                    />
                                    <span>SMS</span>
                                </div>
                            }
                            
                        </div>

                        {
                            this.state.defaultsToggleOn && !isAtLeastOnePublishNotifChannelOn(this.props.notificationSettings, this.props.publishName) &&
                            <div className='select-channel-text-div'>
                                <span className="select-channel-text">Select at least one (1) channel</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    private toggleAuthoring = (event) => {
        let valueToChange = !event.target.checked ? 'none' : 'subscribers';

        if (valueToChange !== 'none') this.setState({defaultsToggleOn: true});

        this.props.setOnPublish(this.props.publishName, event.target.name, valueToChange);
    }

    private onToggleClicked = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const newValue = !this.state.defaultsToggleOn;

        if (!newValue) this.props.setAllOnPublish(this.props.publishName, 'none');

        this.setState({defaultsToggleOn: newValue});
    }

    private getDefaultNotifications = (): {emailDefaultIsNone: boolean, smsDefaultIsNone: boolean, teamsDefaultIsNone: boolean, mobileDefaultIsNone: boolean} => {
        const defaultNotifications = this.props.notificationSettings[this.props.publishName] as Notifications;

        const emailDefaultIsNone = defaultNotifications.emailOnPublish === 'none';
        const smsDefaultIsNone = defaultNotifications.smsOnPublish === 'none';
        const teamsDefaultIsNone = defaultNotifications.teamsOnPublish === 'none';
        const mobileDefaultIsNone = defaultNotifications.mobileOnPublish === 'none';

        return {emailDefaultIsNone, smsDefaultIsNone, teamsDefaultIsNone, mobileDefaultIsNone};
    }    
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        notificationSettings: state.settings.notificationSettings,
        smsManagementEnabled: state.settings.tenantSettings.showFeatures.smsManagementEnabled
    }),
    {
        setOnPublish: actions.SetOnPublish,
        setAllOnPublish: actions.SetAllOnPublish
    }
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default (connector(AuthoringSettings));
